import _ from 'lodash'

class MultipleValuesService {
  constructor() {
  }

  parseStringToArray(string) {
    const splitStrings = string.split(',')
    return _.map(splitStrings, s => _.trim(s))
  }

  collapseArrayToString(values) {
    if(_.isArray(values)) {
      return values.join(', ')
    } else {
      return values
    }
  }

  invalidValues(values, length) {
    return _.filter(values, value => value.length !== length)
  }
}

export default MultipleValuesService
